import {useContext} from 'react'
import {ProductReportContext} from '../../context'
import Search from '../../../../components/Search'

const ProductReportHeader = () => {
  const {onSearch} = useContext(ProductReportContext)

  return (
    <div className='d-flex align-items-center gap-5 flex-wrap mb-10'>
      <Search
        onSearch={(value: string) => onSearch(value)}
      />
    </div>
  )
}

export default ProductReportHeader
